import { TemplateType } from '~/types/template';

const MARKET_PREFIX = `(?:.*/)?`;

const BLOG_PATH_REGEX = new RegExp(`^${MARKET_PREFIX}blogs/[a-zA-Z0-9_-]+($|/)+$`, 'i');
const BLOG_POST_PATH_REGEX = new RegExp(`^${MARKET_PREFIX}blogs/+(.*)/+([\\w]+.*$)`, 'i');
const PRODUCT_PATH_REGEX = new RegExp(`^${MARKET_PREFIX}products+/+([\\w]+.*$)`, 'i');
const COLLECTION_PATH_REGEX = new RegExp(`^${MARKET_PREFIX}collections+/+([\\w]+.*$)`, 'i');
const PAGE_PATH_REGEX = new RegExp(`^${MARKET_PREFIX}pages+/+([\\w]+.*$)`, 'i');
const HOME_PATH_REGEX = new RegExp(`^(/|/[a-zA-Z]{2}-[a-zA-Z]{2,}/?)$`, 'i');

const CART_PATH_REGEX = new RegExp(`^${MARKET_PREFIX}cart(/|$)$`, 'i');
const CHECKOUT_PATH_REGEX = new RegExp(`^${MARKET_PREFIX}checkouts+/+(?:.*)+(/|$)$`, 'i');
const ACCOUNT_PATH_REGEX = new RegExp(`^${MARKET_PREFIX}account(/|$)$`, 'i');
const PASSWORD_PATH_REGEX = new RegExp(`^${MARKET_PREFIX}password(/|$)$`, 'i');
const GIFT_CARD_PATH_REGEX = new RegExp(`^${MARKET_PREFIX}gift_cards(/|$)$`, 'i');
const SEARCH_PATH_REGEX = new RegExp(`^${MARKET_PREFIX}search(/|$)$`, 'i');

export const detectShopifyPageType = (url: string): TemplateType => {
  let path: string;

  try {
    path = new URL(url).pathname;

    if (path === '/' || HOME_PATH_REGEX.test(path)) {
      return TemplateType.HOME;
    }

    if (PRODUCT_PATH_REGEX.test(path)) {
      return TemplateType.PRODUCT;
    }

    if (COLLECTION_PATH_REGEX.test(path)) {
      return TemplateType.COLLECTION;
    }

    if (CART_PATH_REGEX.test(path)) {
      return TemplateType.CART;
    }

    if (CHECKOUT_PATH_REGEX.test(path)) {
      return TemplateType.CHECKOUT;
    }

    if (BLOG_POST_PATH_REGEX.test(path)) {
      return TemplateType.ARTICLE;
    }

    if (BLOG_PATH_REGEX.test(path)) {
      return TemplateType.BLOG;
    }

    if (PAGE_PATH_REGEX.test(path)) {
      return TemplateType.PAGE;
    }

    if (SEARCH_PATH_REGEX.test(path)) {
      return TemplateType.SEARCH;
    }

    if (ACCOUNT_PATH_REGEX.test(path)) {
      return TemplateType.ACCOUNT;
    }

    if (PASSWORD_PATH_REGEX.test(path)) {
      return TemplateType.PASSWORD;
    }

    if (GIFT_CARD_PATH_REGEX.test(path)) {
      return TemplateType.GIFT_CARD;
    }

    return TemplateType.NOT_FOUND;
  } catch (e) {
    console.log(`detectShopifyPageType ~ e:`, e); // eslint-disable-line no-console
    return TemplateType.NOT_FOUND;
  }
};
